import { Pipe, PipeTransform } from '@angular/core';

import { PortalFlightItineraryGroupNode, PortalLeadNode } from '@app/services/api/api.types';
import { getOptionDateChanges, OptionDateChange } from '@app/utils/option-date-changes.util';

@Pipe({
  name: 'optionDateChanges',
  standalone: true,
})
export class OptionDateChangesPipe implements PipeTransform {
  transform(
    itineraries: PortalFlightItineraryGroupNode[] | undefined,
    portalLead?: PortalLeadNode | null,
  ): OptionDateChange[] {
    if (!portalLead || !itineraries?.length) {
      return [];
    }

    return getOptionDateChanges(
      {
        firstTrip: portalLead.firstTrip,
        roundTripDepartureAt: portalLead.roundTripDepartureAt,
        tripType: portalLead.tripType,
      },
      itineraries,
    );
  }
}
